<template>
    <mdb-list-group 
        class="mb-3 mt-0"
    >
        <mdb-list-group-item class="border-primary">
            {{ title }}
        </mdb-list-group-item>
    </mdb-list-group>
</template>

<script>
import {
  mdbListGroup,
  mdbListGroupItem
} from 'mdbvue';

export default {
  name: 'MaterialCard',

  components: {
    mdbListGroup,
    mdbListGroupItem
  },

  props: {
    title: {
      type: String,
      default: ''
    },
  }
}
</script>
